import Color from 'color';

const tntBlue = '#00abc5';
const tntFadedBlue = Color(tntBlue).desaturate(0.5).fade(0.4).string();
const tntAccent = '#ff7100';
const tntGreen = '#50c457';
const tntFadedGreen = Color(tntGreen).desaturate(0.5).fade(0.4).string();
const tntRed = '#d95b4e';
const tntFadedRed = Color(tntRed).desaturate(0.5).fade(0.4).string();
const tntOrange = '#ff9c66';
const tntPink = '#e78cb4';
const tntPurple = '#ae83bf';
const tntYellow = '#d6c953';
const tntTeal = '#27b297';

export {
  tntBlue,
  tntFadedBlue,
  tntAccent,
  tntGreen,
  tntFadedGreen,
  tntRed,
  tntFadedRed,
  tntOrange,
  tntPink,
  tntPurple,
  tntYellow,
  tntTeal,
};



// WEBPACK FOOTER //
// ./src/theme/tntColors.js